import React from "react";
import { LoadingSpinner } from "@/components/ui/spinner";

export const TabSpinner = ({ label = "Loading..." }: { label?: string }) => (
  <LoadingSpinner message={label} className="py-12" />
);
